export const GOOGLE_FIBER_AFFILIATION = 'google fiber';

/**
 *
 * @fileoverview Definition of all custom dimentions.
 */

export type CustomDimension =
  | 'details' // Hit
  | 'region' // User
  | 'fiberhood' // User
  | 'plan' // User
  | 'installed' // User
  | 'connectionStatus' // Hit
  | 'deviceType' // Hit
  | 'pageViewLinkType' // Hit
  | 'inBand' // Session
  | 'digitalInclusionEligible' // User
  | 'pageName' // Page
  | 'pageType'; // Page

export interface ProjectAnalyticsInfo {
  projectType: ProjectType;
  projectSubType: ProjectSubtype;
}

export enum ProjectType {
  UNKNOWN_PROJECT_TYPE = 0,
  // Multiple single family units (residential).
  MULTIPLE_SINGLE_FAMILY_UNITS = 1,
  // Multiple dwelling units (residential).
  MULTIPLE_DWELLING_UNIT = 2,
  // Deprecated.
  MULTI_STORIED_APARTMENTS = 3,
  // Small multiple dwelling units (residential)
  // Designed for apartments with eight or fewer units (on the same parcel).
  // More detailed info can be found in go/wrap-tdd.
  SMALL_MULTIPLE_DWELLING_UNIT = 4,
  // Next ID: 5;
}

export enum ProjectSubtype {
  UNKNOWN_PROJECT_SUBTYPE = 0,
  STANDARD = 1,
  // Bulk Billing with Instant Activation
  FIBER_INSIDE = 2,
  // Free Gig with Instant Activation (a.k.a. pentacle)
  AFFORDABLE_HOUSING = 3,

  // next id: 4
}

export enum BrowserTier {
  UNKNOWN_TIER = 0, // Something went wrong and we couldn't determine the tier.
  TIER_1 = 1, // Fully supported.
  TIER_2 = 2, // May work. Untested.
  TIER_3 = 3, // Not supported. The client should never get here.
}

/**
 * TransactionItemCategory types.
 */
export type TransactionItemCategory =
  | 'plan'
  | 'package'
  | 'device'
  | 'phone'
  | 'add on';

/**
 * TransactionItem interface for GA3 and GA4.
 */
export declare interface TransactionItem {
  id: string;
  name: string;
  affiliation?: string;
  category: TransactionItemCategory;
  coupon?: string;
  discount?: number;
  index?: number;
  item_brand?: string;
  item_category?: string;
  item_category2?: string;
  item_category3?: string;
  item_category4?: string;
  item_category5?: string;
  item_list_id?: string;
  item_list_name?: string;
  item_variant?: string;
  location_id?: string;
  price: number;
  upfrontPrice: number;
  quantity: number;
}

/**
 * Transaction item use for GA3.
 */
export declare interface TransactionItemGa3 {
  id: string;
  name: string;
  category: TransactionItemCategory;
  price: number;
  upfrontPrice: number;
  quantity: number;
}

/**
 * Transaction item use for GA4.
 */
export declare interface TransactionItemGa4 {
  item_id: string;
  item_name: string;
  affiliation?: string;
  coupon?: string;
  discount?: number;
  index?: number;
  item_brand?: string;
  item_category?: string;
  item_category2?: string;
  item_category3?: string;
  item_category4?: string;
  item_category5?: string;
  item_list_id?: string;
  item_list_name?: string;
  item_variant?: string;
  location_id?: string;
  price: number;
  quantity: number;
}

/**
 * Transaction properties used for sending to Google Tag Manager.
 */
export declare interface Transaction {
  id: string;
  affiliation: string;
  revenue: number;
  upfrontRevenue: number;
}
